/**
 * Styled Components - Created by david on 23/02/18.
 */
import styled, { keyframes } from 'styled-components'
import Button from 'antd/lib/button/button'
import { BLUE, GRAY_DARK, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  secondary?: boolean
  selected?: boolean
}

export const Container = styled.div`
  background-color: ${WHITE};
  @media (max-width: 767px) {
    position: relative;
  }
`

export const Text = styled.div`
  color: ${WHITE};
`

export const fadeIn = keyframes`
  to {
    opacity: 1;
  }
`

export const BackCircle = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 16px;
  border-color: #5f6062;
  border-width: 1px;
  border-style: solid;
  border-radius: 50%;
  z-index: 1;
  top: 86px;
  opacity: 0;
  animation: ${fadeIn} 0.5s cubic-bezier(0.67, 0.35, 0.565, 1) both;
  &.customizeTab {
    top: 25%;
  }
`

export const ThemeTabContainer = styled.div`
  width: 100%;
  overflow-y: clip;
`

export const BackIcon = styled.img`
  width: 12px;
  height: 12px;
`

export const StyledTitle = styled.div`
  background-color: ${WHITE};
  padding: 16px 0;
  box-sizing: border-box;
  color: black;
  min-height: 64px;
  font-size: 24px;
  text-align: left;
  flex: 1;
  margin-left: 15px;
  cursor: pointer;
  color: #5f6062;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  text-align: center;
`

export const BottomSheetWrapper = styled.div`
  .react-swipeable-view-container {
    box-shadow: rgba(0, 0, 0, 0.157) 0px -1px 5px !important;
  }

  .shimmer {
    text-align: center;
    color: #00000040;
    background: linear-gradient(
      to left,
      #ff0000,
      #ff00ff,
      #0000ff,
      #00ffff,
      #00ff00,
      #ffff00,
      #ff0000
    );
    background-size: 124px 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-box-decoration-break: clone;
    animation-name: shimmer;
    animation-duration: 15s;
    animation-delay: 15s;
    animation-iteration-count: infinite;
    background-repeat: no-repeat;
    background-position-y: 0;
    background-position-x: -128px;
    background-color: #5f6062;
  }

  @keyframes shimmer {
    0% {
      background-position-x: -128px;
    }
    17%, 100% {
      background-position-x: 168px;
    }
  }
`

export const ModalMessage = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-block: -10px;
  white-space: break-spaces;
`

export const StyledButton = styled(Button)`
  height: 40px;
  border-radius: 5px;
  background-color: #4a90e2;
  border-color: #4a90e2;
  color: ${WHITE};

  &:hover {
    background-color: #6ea6e7;
    border-color: #6ea6e7;
  }
`

export const StyledGhostButton = styled(Button)`
  height: 38px;
  border: 1px solid #302628;
  border-radius: 25px;
  background-color: ${WHITE};
  font-family: Avenir;
  font-weight: 500;
  min-width: 152px;
  transition: color .25s, background: .25s;
  &:hover {
    background: #302628;
    color: ${WHITE};
    border: 1px solid #302628;
  }
  &#back {
    background-color: #302628;
    color: ${WHITE};
    :hover {
      background: ${WHITE};
      color: #302628;
      border: 1px solid #302628;
    }
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
`

export const Error = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const Title = styled.div`
  color: #5f6062;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const ErrorMessage = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const MobileToolBar = styled.div`
  display: flex;
  background-color: ${WHITE};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  height: 50px;
  position: absolute;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const MobileTitle = styled.h2`
  margin: 0 0 0 55px;
  color: #5f6062;
  font-family: 'Avenir Next';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2px;
`
export const ActionMobileItems = styled.div`
  height: 100%;
  width: 120px;
  display: flex;
`

export const MobileItem = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  &:first-child {
    border-left: 0.5px solid #dcdcdc;
    border-right: 0.5px solid #dcdcdc;
  }
  &:last-child {
    border-right: 0.5px solid #dcdcdc;
  }
`
export const ButtonImg = styled.img``

export const ButtonText = styled.p`
  font-size: 10px;
  margin: 0;
`

export const DesigningFor = styled.div`
  position: fixed;
  left: 20%;
  background: #7dafd8;
  color: white;
  padding: 6px 18px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  z-index: 9;
  box-shadow: 0px 2px 4px -2px #878686;
  padding-left: 40px;
`

export const UserIcon = styled(Icon)`
  margin-right: 12px;
  background: white;
  color: #7dafd8;
  padding: 8px;
  border-radius: 25px;
  position: absolute;
  left: -2px;
  top: -2px;
  border: 1px solid #7dafd8;
  border-top-left-radius: 0;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  color: ${WHITE};
  font-size: 18px;
`

export const TitleComplete = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #538264;
`

export const CheckComplete = styled(Icon)`
  color: green;
  margin-right: 10px;
`

export const EditContentComplete = styled.div`
  margin: 22px 0 0 -38px;
  text-align: center;
`

export const EditContent = styled.div`
  margin: 22px 0 0 -38px;
  text-align: center;
  color: ${WHITE};
`

export const ModalTitleWarn = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoMessage = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: -28px;
  background: #272727;
  vertical-align: middle;
  color: white;
`

export const FingerIcon = styled(Icon)`
  width: 24px;
  padding: 2px 0;
  margin-top: -4px;
  z-index: 2;
  background: #272727;
  margin-right: 4px !important;
  margin-left: -4px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 12px 0 12px -38px;
`

export const WarningIcon = styled(Icon)`
  margin-right: 12px;
  color: #FE7E00;
`

export const completeButtonProps = {
  background: BLUE,
  borderColor: BLUE
}

export const TabsBottom = styled.div`
  top: -35px;
  position: absolute;
  left: calc(50vw - 148px);
  display: flex;
  align-items: flex-end;
  transition: all 0.3s ease;
`

export const TabsLabel = styled.div`
  font-size: 16px;
  padding: 6px 14px;
  font-weight: 500;
  font-family: Avenir;
  color: #302628;
  background-color: #E8E5E5;
  box-shadow: 2px -5px 6px -3px #cfcfcf;
  border-radius: 10px 10px 0px 0px;
  border: 1.5px solid #727272;
  border-bottom: none;
  margin-right: 12px;
  min-width: 164px;
  text-align: center;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    padding-bottom: 20px;
    margin-top: -15px;
    opacity: ${({ selected }: DivProps) => selected ? '1' : '0.8'};
  }
  &:last-child {
    margin-right: 0px;
  }
  ${({ selected }: DivProps) => selected ? `background-color: ${WHITE};` : ''}
`

export const StyledTitleTab = styled.div`
  background-color: ${WHITE};
  color: #5f6062;
  box-sizing: border-box;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignCenterEnhanced/styledComponents.tsx